"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("../utils");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _DatePickerField = _interopRequireDefault(require("../DatePickerField"));
var _errorHandlerUtility = _interopRequireDefault(require("../utils/errorHandlerUtility"));
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validateIsRequired = (value, isRequired) => {
  var isValid = true;
  isValid = isValid && (isRequired ? value.length > 0 : true);
  return isValid;
};
var validateLength = value => {
  var isValid = true;
  isValid = isValid && value.length > 0;
  return isValid;
};
var dateLanguageFormats = {
  en: 'MMM_D__YYYY',
  fr: 'D_MMM__YYYY'
};
var formatDateTimeSlots = (dateTimeSlots, language) => {
  var format = dateLanguageFormats[language] || dateLanguageFormats.en;
  return dateTimeSlots.map(slot => {
    return _objectSpread(_objectSpread({}, slot), {}, {
      value: slot !== null && slot !== void 0 && slot.value ? (0, _moment.default)(slot.value, format).format('MMM_DD__YYYY').replace(/\W/g, '_') : ''
    });
  });
};
var formatDates = data => data === null || data === void 0 ? void 0 : data.map(item => (0, _moment.default)(item === null || item === void 0 ? void 0 : item.date).format('YYYY/MM/DD'));
var GenesysTimeSlotsField = props => {
  var {
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    isRequired = true,
    inputRef = /*#__PURE__*/_react.default.createRef(),
    clickedSubmit = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    customErrorMessageSelect = '',
    customErrorMessageDatePicker = '',
    selectLabel = _staticContent.GENESYSTIMESLOTS_DROPDOWN_FIELD.DEFAULT_LABEL,
    datepickerLegend = _staticContent.GENESYSTIMESLOTS_PICKER_FIELD.DEFAULT_LABEL,
    hint = null,
    environment,
    onChange = () => {},
    fieldData = {},
    existingValue = [],
    initialValue,
    brand,
    subBrand,
    displayDays,
    productType,
    customerIntent,
    businessDomain
  } = props;
  var [timeSlots, setTimeSlots] = (0, _react.useState)([]);
  var [data, setData] = (0, _react.useState)([]);
  var [timeValue, setTimeValue] = (0, _react.useState)('');
  var [validationSelectError, setValidationSelectError] = (0, _react.useState)(undefined);
  var [validationSelectFeedback, setValidationSelectFeedback] = (0, _react.useState)(undefined);
  var [validationError, setValidationError] = (0, _react.useState)(undefined);
  var [validationFeedback, setValidationFeedback] = (0, _react.useState)(undefined);
  var [isLoading, setIsLoading] = (0, _react.useState)(true);
  var {
    buttonControlPressed,
    currentStepReferences,
    steps
  } = (0, _useStepTrackerContext.default)();
  (0, _react.useEffect)(() => {
    if (isLoading) {
      if (existingValue.length > 0) {
        setIsLoading(false);
        setData(formatDateTimeSlots(existingValue, language));
        return;
      }
      var getGenesysData = setTimeout(() => {
        makeGenesysPostRequest().then(response => response.json()).then(resData => {
          setData(formatDateTimeSlots(resData, language));
          setIsLoading(false);
        }).catch(error => {
          setIsLoading(false);
          _errorHandlerUtility.default.report(JSON.stringify({
            message: "Failed to make a POST request and fetch data on get time slots Genesys - ".concat(error),
            fileName: 'GenesysTimeSlotsField/index.jsx',
            methodName: 'getGenesysData'
          }));
        });
      }, 500);
      return () => clearTimeout(getGenesysData);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var makeGenesysPostRequest = () => {
    var _fieldData$current;
    var result = (0, _utils.extractFieldValues)(steps, 'phoneNumber');
    var phoneNumberValue = result.length > 0 ? fieldData === null || fieldData === void 0 || (_fieldData$current = fieldData.current) === null || _fieldData$current === void 0 || (_fieldData$current = _fieldData$current[result[0].id]) === null || _fieldData$current === void 0 ? void 0 : _fieldData$current.value : undefined;
    var bodyParams = {
      phoneNumber: phoneNumberValue,
      lang: language,
      adapterData: {
        payload: {
          _brand: brand,
          _subBrand: subBrand,
          _displayDays: displayDays,
          _productType: productType,
          _customerIntent: customerIntent,
          _businessDomain: businessDomain
        }
      },
      environment: environment
    };
    return (0, _utils.makeHTTPRequest)(JSON.stringify(bodyParams), _constants.HEADER_ACCESS_TOKEN, false, _constants.HEADER_ACCESS_CONFIG_AMS_API_VALUE, 'genesysDateTimeSlots', _constants.HTTP_POST);
  };
  var updateValidationSelectError = (0, _react.useCallback)(isValid => {
    setValidationSelectError(isValid ? undefined : customErrorMessageSelect || _staticContent.GENESYSTIMESLOTS_DROPDOWN_FIELD.VALIDATION_ERROR[language]);
    setValidationSelectFeedback(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
  }, [customErrorMessageSelect, language]);
  var updateValidationButtonError = (0, _react.useCallback)(isValid => {
    setValidationError(isValid ? undefined : customErrorMessageDatePicker || _staticContent.GENESYSTIMESLOTS_PICKER_FIELD.VALIDATION_ERROR[language]);
    setValidationFeedback(isValid ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
  }, [customErrorMessageDatePicker, language]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      updateValidationSelectError(validateIsRequired(timeValue, isRequired));
    }
  }, [clickedSubmit, isRequired, updateValidationSelectError, updateValidationButtonError, timeValue]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        updateValidationSelectError(validateIsRequired(timeValue, isRequired));
      }
    }
  }, [buttonControlPressed, inputRef, currentStepReferences, updateValidationSelectError, timeValue, isRequired]);
  var formattedDates = formatDates(data);
  var onFieldChange = date => {
    setTimeValue(date);
  };
  var handleDateChange = val => {
    var datepicker_to_slots_format = (0, _moment.default)(val).format('MMM_DD__YYYY');
    var availableTimeSlots = data.find(_ref => {
      var {
        value
      } = _ref;
      return value === datepicker_to_slots_format;
    });
    return setTimeSlots((availableTimeSlots === null || availableTimeSlots === void 0 ? void 0 : availableTimeSlots.timeSlots) === undefined ? [] : availableTimeSlots.timeSlots);
  };
  var selectOptions = timeSlots === null || timeSlots === void 0 ? void 0 : timeSlots.map((_ref2, index) => {
    var {
      value,
      text
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_componentsWeb.Select.Item, {
      key: index,
      value: value
    }, text);
  });
  var skeletonComponent = (label, isRequired, language) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.Typography, {
      block: true,
      variant: {
        size: 'medium',
        bold: true
      }
    }, (0, _utils.formatLabel)(label, isRequired, language)), /*#__PURE__*/_react.default.createElement(_componentsWeb.Skeleton, {
      sizeIndex: 6,
      characters: 30
    }));
  };
  (0, _react.useEffect)(() => {
    if (timeValue === '') return;
    onChange(timeValue, validateLength(timeValue));
  }, [timeValue, onChange]);
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.StackView, {
    space: 2
  }, /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, data.length > 0 ? /*#__PURE__*/_react.default.createElement(_DatePickerField.default, {
    ref: inputRef,
    hintPosition: hintPosition,
    hint: hint,
    isRequired: isRequired,
    label: (0, _utils.formatLabel)(datepickerLegend, isRequired, language),
    onChange: handleDateChange,
    fieldName: 'GenesysDateTime',
    customErrorMessage: customErrorMessageDatePicker,
    datePickerType: _staticContent.DATEPICKER_FIELD.DATEPICKER_TYPE[1],
    dateSlots: formattedDates,
    feedback: validationError,
    validation: validationFeedback,
    value: initialValue,
    language: language
  }) : skeletonComponent(datepickerLegend, isRequired, language)), /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, data.length > 0 ? /*#__PURE__*/_react.default.createElement(_componentsWeb.Select, {
    label: (0, _utils.formatLabel)(selectLabel, isRequired, language),
    value: timeValue,
    onChange: onFieldChange,
    validation: validationSelectFeedback,
    feedback: validationSelectError
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Select.Item, {
    value: ''
  }, _staticContent.GENESYSTIMESLOTS_DROPDOWN_FIELD.PLACEHOLDER[language]), selectOptions) : skeletonComponent(selectLabel, isRequired, language)), !isLoading && data.length === 0 && /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.Feedback, {
    validation: "error",
    variant: {
      icon: true
    },
    title: _staticContent.GENESYS_FIELD.TITLE_ERROR_NO_DATA[language]
  }, _staticContent.GENESYS_FIELD.VALIDATION_ERROR_NO_DATA[language])));
};
GenesysTimeSlotsField.propTypes = {
  selectLabel: _propTypes.default.string,
  datepickerLegend: _propTypes.default.string,
  hint: _propTypes.default.string,
  inputRef: _propTypes.default.object,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  customErrorMessageSelect: _propTypes.default.string,
  customErrorMessageDatePicker: _propTypes.default.string,
  fieldValues: _propTypes.default.object,
  environment: _propTypes.default.string,
  onChange: _propTypes.default.func,
  existingValue: _propTypes.default.array,
  initialValue: _propTypes.default.string,
  brand: _propTypes.default.string,
  subBrand: _propTypes.default.string,
  displayDays: _propTypes.default.string,
  productType: _propTypes.default.string,
  customerIntent: _propTypes.default.string,
  businessDomain: _propTypes.default.string
};
var _default = exports.default = GenesysTimeSlotsField;